type Listener = () => void

const listeners = new Set<Listener>()
/** Giữ trạng thái tới khi reload — listener đăng ký muộn vẫn biết phiên đã hết. */
let expired = false

export const isSessionExpired = (): boolean => expired

export const emitSessionExpired = (): void => {
  expired = true
  listeners.forEach((listener) => listener())
}

export const onSessionExpired = (listener: Listener): (() => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
